<template lang="pug">
  .observer(
    ref="observable"
  )
    slot(
      v-if="loaded"
    )
</template>

<script>
  import IOLazyLoader from 'scripts/mixins/IOLazyLoader.js';

  export default {
    name: 'IoLazyLoad',
    props: {
      margin: {
        type: String,
        default: '0%',
      },
    },
    mixins: [IOLazyLoader],
  };
</script>
